import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence, onAuthStateChanged, User as FirebaseUser } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Configuration Firebase avec valeurs par défaut pour éviter les erreurs
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'placeholder-api-key',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'placeholder-project.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'placeholder-project',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'placeholder-project.appspot.com',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '000000000000',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:000000000000:web:0000000000000000000000',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'G-0000000000'
};

// Avertissement si les variables d'environnement sont manquantes
if (!import.meta.env.VITE_FIREBASE_API_KEY) {
  console.warn('⚠️ Variables d\'environnement Firebase manquantes. L\'application fonctionnera en mode dégradé.');
}

// Initialize Firebase only if it hasn't been initialized yet
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Get Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Configure auth persistence with stronger settings
const initializeAuth = async () => {
  try {
    // Définir la persistance sur LOCAL (conserve les données même après fermeture du navigateur)
    await setPersistence(auth, browserLocalPersistence);
    
    // Vérifier si l'authentification fonctionne correctement
    const unsubscribe = onAuthStateChanged(auth, (user: FirebaseUser | null) => {
      if (user) {
        console.log('Utilisateur authentifié détecté:', user.uid);
      } else {
        console.log('Aucun utilisateur authentifié');
      }
    });
    
    // Nettoyer l'écouteur après la première vérification
    setTimeout(() => {
      unsubscribe();
    }, 5000);
    
    console.log('Persistance de l\'authentification configurée avec succès (mode: LOCAL)');
  } catch (error) {
    console.error('Erreur lors de la configuration de la persistance:', error);
  }
};

// Initialize auth persistence immediately
initializeAuth();

// Vérifier si l'authentification est stockée dans localStorage
const checkAuthStorage = () => {
  const authKeys = Object.keys(localStorage).filter(key => 
    key.startsWith('firebase:authUser')
  );
  
  if (authKeys.length > 0) {
    console.log('Données d\'authentification trouvées dans localStorage');
  } else {
    console.warn('Aucune donnée d\'authentification trouvée dans localStorage');
  }
};

// Vérifier le stockage après un court délai
setTimeout(checkAuthStorage, 2000);

export { auth, db, storage };
